/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Zalify has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

(function () {
    function fixRawnessGiftSeasonCta() {
        var section = document.getElementById('shopify-section-template--24389861146943__image_with_text_overlay_9nAaVi');
        if (!section) {
            return;
        }

        var button = section.querySelector('a.button');
        if (!button) {
            return;
        }

        if (!button.getAttribute('href')) {
            button.setAttribute('href', '/collections/best-sellers');
        }

        if (button.textContent.trim().toUpperCase() === 'DICOVER') {
            button.textContent = 'DISCOVER';
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fixRawnessGiftSeasonCta);
    } else {
        fixRawnessGiftSeasonCta();
    }

    document.addEventListener('shopify:section:load', fixRawnessGiftSeasonCta);
})();

(function () {
  function mountRawnessStickyAtc(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;

    scope.querySelectorAll('.rawness-sticky-atc').forEach(function (bar) {
      if (bar.dataset.rawnessMounted === 'true') return;

      var section = bar.closest('.shopify-section--main-product') || document;
      var source = section.querySelector('#MainPaymentContainer');
      if (!source) return;

      bar.dataset.rawnessMounted = 'true';

      var mobile = window.matchMedia('(max-width: 740px)');
      var rect = source.getBoundingClientRect();
      var sourceVisible = rect.bottom > 0 && rect.top < window.innerHeight;

      function update() {
        var visible = mobile.matches && !sourceVisible;
        bar.classList.toggle('is-visible', visible);
        document.body.classList.toggle('rawness-sticky-atc-visible', visible);
      }

      var observer = new IntersectionObserver(function (entries) {
        sourceVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0.01 });

      observer.observe(source);
      bar.rawnessStickyObserver = observer;

      if (mobile.addEventListener) {
        mobile.addEventListener('change', update);
      } else {
        mobile.addListener(update);
      }

      update();
    });
  }

  function mountAll(root) {
    mountRawnessStickyAtc(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      mountAll(document);
    });
  } else {
    mountAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    mountAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.rawness-sticky-atc').forEach(function (bar) {
      if (bar.rawnessStickyObserver) bar.rawnessStickyObserver.disconnect();
    });
    document.body.classList.remove('rawness-sticky-atc-visible');
  });
})();


(function () {
  if (document.documentElement.dataset.rawnessSelectItemTracking === 'true') return;

  document.documentElement.dataset.rawnessSelectItemTracking = 'true';

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : event.target.parentElement;
    var link = target && target.closest('a[href*="/products/"]');
    var productItem = link && link.closest('product-item');

    if (!productItem) return;

    var url = new URL(link.href, window.location.origin);
    var handleMatch = url.pathname.match(/^\/products\/([^/]+)/);

    if (!handleMatch) return;

    var list = productItem.closest('product-list');
    var section = list && list.closest('.shopify-section');
    var heading = section && section.querySelector('h1, h2, h3, [role="heading"]');
    var fallbackHeading = document.querySelector('main h1');
    var itemTitle = productItem.querySelector('.product-item-meta__title');
    var items = list ? Array.prototype.slice.call(list.querySelectorAll('product-item')) : [];
    var itemIndex = items.indexOf(productItem);
    var payload = {
      item_list_id: section && section.id ? section.id : window.location.pathname,
      item_list_name: (heading || fallbackHeading) ? (heading || fallbackHeading).textContent.trim() : document.title,
      items: [{
        item_id: decodeURIComponent(handleMatch[1]),
        item_name: itemTitle ? itemTitle.textContent.trim() : link.textContent.trim(),
        item_brand: 'RAWNESS',
        index: itemIndex < 0 ? 0 : itemIndex
      }]
    };

    try {
      var published = window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish(
        'rawness:select_item',
        payload
      );

      if (published && typeof published.catch === 'function') {
        published.catch(function () {});
      }
    } catch (error) {
      // Tracking must never interrupt product navigation.
    }
  }, true);
})();


/* Keep the icon-only Shopify Inbox activator accessible */
(function () {
  var attempts = 0;
  var timer;

  function labelChatButton() {
    var host = document.getElementById('ShopifyChat');
    var button = host && host.shadowRoot && host.shadowRoot.querySelector('[data-spec="toggle-button"]');

    if (!button) {
      return false;
    }

    button.setAttribute('aria-label', 'Chat with RAWNESS');

    if (!host.rawnessChatLabelObserver) {
      host.rawnessChatLabelObserver = new MutationObserver(function () {
        labelChatButton();
      });
      host.rawnessChatLabelObserver.observe(host.shadowRoot, { childList: true, subtree: true });
    }

    return true;
  }

  function mountChatLabel() {
    window.clearInterval(timer);
    attempts = 0;

    if (labelChatButton()) {
      return;
    }

    timer = window.setInterval(function () {
      attempts += 1;

      if (labelChatButton() || attempts >= 40) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountChatLabel);
  } else {
    mountChatLabel();
  }

  document.addEventListener('shopify:section:load', mountChatLabel);
})();


/* Hide the sticky CTA while real purchase controls are visible */
(function () {
  function mountPurchaseControlGate(root) {
    var scope = root || document;
    var section = scope.matches && scope.matches('.shopify-section--main-product')
      ? scope
      : scope.querySelector && scope.querySelector('.shopify-section--main-product');

    if (!section || section.dataset.rawnessPurchaseControlGateMounted === 'true') {
      return;
    }

    var controls = Array.prototype.slice.call(
      section.querySelectorAll(
        '.product-form__option-selector, .product-form__quantity, #MainPaymentContainer'
      )
    );

    if (!controls.length) {
      return;
    }

    section.dataset.rawnessPurchaseControlGateMounted = 'true';

    var visibility = new Map();
    var mobile = window.matchMedia('(max-width: 740px)');

    function isInViewport(control) {
      var rect = control.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
    }

    function update() {
      var controlsVisible = false;

      visibility.forEach(function (visible) {
        if (visible) {
          controlsVisible = true;
        }
      });

      document.body.classList.toggle(
        'rawness-purchase-controls-in-view',
        mobile.matches && controlsVisible
      );
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        visibility.set(entry.target, entry.isIntersecting);
      });

      update();
    }, { threshold: 0.01 });

    controls.forEach(function (control) {
      visibility.set(control, isInViewport(control));
      observer.observe(control);
    });

    section.rawnessPurchaseControlGateObserver = observer;

    if (mobile.addEventListener) {
      mobile.addEventListener('change', update);
    } else {
      mobile.addListener(update);
    }

    update();
  }

  function mountAll(root) {
    mountPurchaseControlGate(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      mountAll(document);
    });
  } else {
    mountAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    mountAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target;

    if (section.rawnessPurchaseControlGateObserver) {
      section.rawnessPurchaseControlGateObserver.disconnect();
    }

    document.body.classList.remove('rawness-purchase-controls-in-view');
  });
})();


/* Keep mobile product media stable while Flickity initializes */
(function () {
  function mountProductMediaStabilizer(root) {
    var scope = root || document;
    var mediaElements = [];

    if (
      scope.matches &&
      scope.matches('.shopify-section--main-product .product__media--mobile-expanded')
    ) {
      mediaElements = [scope];
    } else if (scope.querySelectorAll) {
      mediaElements = Array.prototype.slice.call(
        scope.querySelectorAll(
          '.shopify-section--main-product .product__media--mobile-expanded'
        )
      );
    }

    mediaElements.forEach(function (media) {
      if (
        media.dataset.rawnessMediaStabilizerMounted === 'true' ||
        !window.matchMedia('(max-width: 740px)').matches
      ) {
        return;
      }

      var list = media.querySelector(
        ':scope > .product__media-list-wrapper > .product__media-list'
      );
      var initialWrapper = media.querySelector(
        '.product__media-item.is-initial-selected .product__media-image-wrapper'
      );

      if (!list || !initialWrapper) {
        return;
      }

      var existingViewport = list.querySelector(':scope > .flickity-viewport');
      if (
        list.classList.contains('flickity-enabled') &&
        existingViewport &&
        parseFloat(existingViewport.style.height) > 0
      ) {
        return;
      }

      var ratio = parseFloat(
        initialWrapper.style.getPropertyValue('--aspect-ratio')
      );
      var image = initialWrapper.querySelector('img[width][height]');

      if (!(ratio > 0) && image) {
        ratio =
          parseFloat(image.getAttribute('width')) /
          parseFloat(image.getAttribute('height'));
      }

      if (!(ratio > 0)) {
        ratio = 1;
      }

      media.dataset.rawnessMediaStabilizerMounted = 'true';
      media.style.setProperty(
        '--rawness-initial-media-aspect-ratio',
        String(ratio)
      );
      media.classList.add('rawness-media-initializing');

      var releaseTimer = null;
      var observer = new MutationObserver(function () {
        queueRelease();
      });

      function queueRelease() {
        var viewport = list.querySelector(':scope > .flickity-viewport');
        var ready =
          list.classList.contains('flickity-enabled') &&
          viewport &&
          parseFloat(viewport.style.height) > 0;

        if (!ready || releaseTimer) {
          return;
        }

        releaseTimer = window.setTimeout(function () {
          media.classList.remove('rawness-media-initializing');
          observer.disconnect();
          media.rawnessMediaStabilizerObserver = null;
          media.rawnessMediaStabilizerTimer = null;
        }, 350);

        media.rawnessMediaStabilizerTimer = releaseTimer;
      }

      observer.observe(list, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class', 'style']
      });

      media.rawnessMediaStabilizerObserver = observer;
      queueRelease();
    });
  }

  function mountAll(root) {
    mountProductMediaStabilizer(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      mountAll(document);
    });
  } else {
    mountAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    mountAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target
      .querySelectorAll('.product__media--mobile-expanded')
      .forEach(function (media) {
        if (media.rawnessMediaStabilizerObserver) {
          media.rawnessMediaStabilizerObserver.disconnect();
        }
        if (media.rawnessMediaStabilizerTimer) {
          window.clearTimeout(media.rawnessMediaStabilizerTimer);
        }
      });
  });
})();

(function () {
  function mountInitialVariantMediaSync(root) {
    var scope = root || document;
    var mediaElements = [];

    if (
      scope.matches &&
      scope.matches('.shopify-section--main-product product-media[form-id]')
    ) {
      mediaElements = [scope];
    } else if (scope.querySelectorAll) {
      mediaElements = Array.prototype.slice.call(
        scope.querySelectorAll(
          '.shopify-section--main-product product-media[form-id]'
        )
      );
    }

    mediaElements.forEach(function (media) {
      if (
        media.dataset.rawnessInitialVariantMediaSyncMounted === 'true'
      ) {
        return;
      }

      var carousel = media.querySelector('flickity-carousel');
      if (!carousel || media.querySelectorAll('.product__media-item').length <= 1) {
        media.dataset.rawnessInitialVariantMediaSyncMounted = 'true';
        return;
      }

      media.dataset.rawnessInitialVariantMediaSyncMounted = 'true';

      var section =
        media.closest('.shopify-section--main-product') || document;
      var formId = media.getAttribute('form-id');
      var attempts = 0;
      var timer = window.setInterval(function () {
        attempts += 1;

        var form = document.getElementById(formId);
        var variants = section.querySelector(
          'product-variants[form-id="' + CSS.escape(formId) + '"]'
        );
        var variant = null;

        try {
          variant = variants && variants.selectedVariant;
        } catch (error) {
          variant = null;
        }

        if (
          form &&
          media.product &&
          variants &&
          variants.product &&
          variant
        ) {
          window.clearInterval(timer);
          media.rawnessInitialVariantMediaSyncTimer = null;

          var featuredMedia = variant.featured_media;
          var selectedMedia = media.querySelector(
            '.product__media-item.is-selected'
          );
          var selectedMediaId =
            selectedMedia && selectedMedia.getAttribute('data-media-id');

          if (
            featuredMedia &&
            String(featuredMedia.id) !== String(selectedMediaId)
          ) {
            form.dispatchEvent(
              new CustomEvent('variant:changed', {
                bubbles: true,
                detail: { variant: variant }
              })
            );
          }

          return;
        }

        if (attempts >= 50) {
          window.clearInterval(timer);
          media.rawnessInitialVariantMediaSyncTimer = null;
        }
      }, 100);

      media.rawnessInitialVariantMediaSyncTimer = timer;
    });
  }

  function mountAll(root) {
    mountInitialVariantMediaSync(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      mountAll(document);
    });
  } else {
    mountAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    mountAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target
      .querySelectorAll(
        '.shopify-section--main-product product-media[form-id]'
      )
      .forEach(function (media) {
        if (media.rawnessInitialVariantMediaSyncTimer) {
          window.clearInterval(media.rawnessInitialVariantMediaSyncTimer);
        }
      });
  });
})();
